import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

type Guard<T> = (value: unknown) => value is T

const isString: Guard<string> = (value): value is string => typeof value === "string"

export function dig<T>(
  obj: unknown,
  guard: Guard<T>,
  ...keys: string[]
): T | undefined {
  let cur: unknown = obj

  for (const key of keys) {
    if (typeof cur !== "object" || cur === null) {
      return guard(cur) ? cur : undefined
    }

    if (!(key in cur)) return undefined
    cur = (cur as Record<string, unknown>)[key]
  }

  return guard(cur) ? cur : undefined
}

export function digStr(obj: unknown, ...keys: string[]): string | undefined {
  return dig<string>(obj, isString, ...keys)
}

export function formatValue(value: any): string {
  if (value === null || value === undefined) {
    return "N/A"
  }

  if (typeof value === "boolean") {
    return value ? "Yes" : "No"
  }

  if (typeof value === "object") {
    return JSON.stringify(value, null, 2)
  }

  return String(value)
}

export function getCSRFToken(): string | null {
  const csrfToken = document
    .querySelector('meta[name="csrf-token"]')
    ?.getAttribute('content');
  return csrfToken || null;
}


